import { idmsApi } from "./api";
import { API_ADDONS_ENDPOINT } from "../../constants/endpoints";

export const addonsApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductAddOns: builder.query<AddOnCatalogItemDto[], string>({
      // arg = productId
      query: (productId) => `${API_ADDONS_ENDPOINT}/product/${productId}`,
      providesTags: (result, _err, productId) => [{ type: "AddOns", id: productId }],
    }),
    getDealerActiveAddOns: builder.query<DealerActiveAddOnsDto, { dealerId: number; productId: string }>({
      query: ({ dealerId, productId }) => `${API_ADDONS_ENDPOINT}/dealer/${dealerId}/product/${productId}`,
    }),
    assignAddOn: builder.mutation<void, DealerAddOnChangeRequest>({
      query: (body) => ({
        url: `${API_ADDONS_ENDPOINT}/assign`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, _err, arg) => [{ type: "AddOns", id: arg.productId.toString() }],
    }),
    unassignAddOn: builder.mutation<void, DealerAddOnChangeRequest>({
      query: (body) => ({
        url: `${API_ADDONS_ENDPOINT}/unassign`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, _err, arg) => [{ type: "AddOns", id: arg.productId.toString() }],
    }),

    markProductFeatureAsAddOn: builder.mutation<void, { productId: string; featureId: string; notes?: string }>({
      query: ({ productId, featureId, notes }) => ({
        url: `${API_ADDONS_ENDPOINT}/product/${productId}/feature/${featureId}`,
        method: "POST",
        body: { notes },
      }),
      invalidatesTags: (result, _err, arg) => [
        { type: "AddOns", id: arg.productId },
        { type: "ProductFeatures", id: arg.productId },
      ],
    }),

    unmarkProductFeatureAsAddOn: builder.mutation<void, { productId: string; featureId: string }>({
      query: ({ productId, featureId }) => ({
        url: `${API_ADDONS_ENDPOINT}/product/${productId}/feature/${featureId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, _err, arg) => [
        { type: "AddOns", id: arg.productId },
        { type: "ProductFeatures", id: arg.productId },
      ],
    }),
  }),
});

export const {
  useGetProductAddOnsQuery,
  useGetDealerActiveAddOnsQuery,
  useAssignAddOnMutation,
  useUnassignAddOnMutation,
  useMarkProductFeatureAsAddOnMutation,
  useUnmarkProductFeatureAsAddOnMutation,
} = addonsApi;
